import { render, staticRenderFns } from "./VideoBottomBar.vue?vue&type=template&id=6806f03e&scoped=true"
import script from "./VideoBottomBar.vue?vue&type=script&lang=js"
export * from "./VideoBottomBar.vue?vue&type=script&lang=js"
import style0 from "./VideoBottomBar.vue?vue&type=style&index=0&id=6806f03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6806f03e",
  null
  
)

export default component.exports